import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PAGE_NAME } from '../../config/pageNames';
import Footer from '../../components/Footer/Footer';
import HowItWorks from './HowItWorks';
import LandingCarousel from './LandingCarousel';
import SharedLandingPage from '../../../shared-components/SharedLandingPage/SharedLandingPage';
import './LandingPage.less';

export class LandingPage extends Component {
    render() {
        return (
            <SharedLandingPage
                Footer={Footer}
                HowItWorks={HowItWorks}
                LandingCarousel={LandingCarousel}
                nextPage={PAGE_NAME.BILLING_PAGE}
            />
        );
    }
}

export default connect()(LandingPage);
